import authService from './authService';

// Configuración dinámica de la URL de la API
const API_BASE_URL = process.env.REACT_APP_API_URL || 
  (window.location.origin.includes('localhost') ? 'http://localhost:8080/api' : `${window.location.origin}/api`);

export const subscribe = async (email, source = 'general') => {
  try {
    const response = await fetch(`${API_BASE_URL}/subscribe`, {
      method: 'POST',
      headers: authService.getAuthHeaders(),
      body: JSON.stringify({ email, source }),
    });

    if (!response.ok) {
      throw new Error('Error al suscribirse');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en el servicio de suscripción:', error);
    throw error;
  }
};
